module.exports = __webpack_public_path__ + "static/media/0311_Medium.329932a7.jpg";